import { useState } from 'react'
import ConnectedAds from '@components/blog/components/post/ConnectedAds'
import NavLinkButton from '@components/shared/NavLinkButton'
import NavLinkColor from '@components/shared/NavLinkColor'
import Icon from '@components/shared/Icon'

export default function ConnectedAdsViewMore ({
    connectedAds,
    max = 3,
    text = '',
    url,
    useCategoryLink = true
}) {
    if (!Array.isArray(connectedAds) || connectedAds.length < 1) return null

    const [more,setMore] = useState(false)

    const toggle = () => setMore(!more)
    const displayMoreButton = connectedAds.length > max

    const moreButton = displayMoreButton && <div style={{display:'flex',justifyContent:'center'}}>
        <NavLinkButton onClick={toggle} color="teal">
            {`Zobacz wszystkie ${text}`} <Icon>arrow_right_alt</Icon>
        </NavLinkButton>
    </div>

    const categoryLink = useCategoryLink && <div style={{display:'flex',justifyContent:'center'}}>
        <NavLinkColor
            color="teal"
            iconRight={<Icon>arrow_right_alt</Icon>}
            t={`Zobacz wszystkie ${text}`}
            to={url} />
    </div>

    const preview = connectedAds.slice(0, max)
    const remaining = connectedAds.slice(max)

    return <>
        <ConnectedAds connectedAds={preview} title={null} />
        { useCategoryLink
            ? categoryLink
            : <>
                { !more && moreButton }
                { more && <ConnectedAds connectedAds={remaining} title={null} /> }
              </> }
        <br/><br/><br/>
    </>
}